<template>
  <div style="height: 100vh; width: 100%">
    <div style="width: 100%; display: none; height: 0%">
      <img id="imageid" :src="profpic" />
      <canvas id="imgCanvas" />
      <pdf-make
        ref="pdfMake"
        style="width: 100%"
        :content="content"
        :pageSize="'A4'"
        :pageOrientation="'portrait'"
        :show="true"
        :info="{ title: title }"
        @change="
          (e) => {
            src = e;
          }
        "
      >
      </pdf-make>
    </div>
    <iframe
      id="content-frame"
      :src="src"
      style="width: 100%; display: inline-block; height: 100%"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
import PdfMake from "@/components/PdfMake";
// import {docContent} from '@/data/TemplateSuratRujukBalik.js'
import { headerImage } from "@/data/headerImage.js";
import { labelValueFormatter } from "@/data/helper.js";
// import ttf from 'url-loader!@/assets/微软雅黑.ttf'
//console.log(ttf)
export default {
  name: "DocSuratRujukBalik",
  components: {
    PdfMake,
  },
  data() {
    return {
      title: "Surat Rujuk Balik",
      src: "",
      content: [],
      ralan: {},
      profpic: "https://103.27.207.58/backend/public/images/icon_customer.png",
    };
  },
  methods: {
    executeDocument: function() {
      document.getElementById("content-frame").contentWindow.window.print();
    },
    toDataUrl: function(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function() {
        var reader = new FileReader();
        reader.onloadend = function() {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    this.ralan = JSON.parse(
      this.CryptoJS.AES.decrypt(
        this.$route.params.slug.replace(/fRWdSl45h/g, "/"),
        this.$store.state.simrsSecretPassphrase
      ).toString(this.CryptoJS.enc.Utf8)
    );
    // this.content = docContent;
    var draft = {
      title: "SURAT RUJUK BALIK",
      subtitle: "No. : _________________/20__",
      intro: `Teman Sejawat Yth.
      Mohon kontrol selanjutnya penderita`,
      p1: "",
      arr1: [
        {
          label: "Nama Pasien",
          vaDokterlue: `${this.ralan.pasien.nama}  (${this.ralan.pasien.jen_kelamin})`,
        },
        // { label: "No. RM", value: this.ralan.pasien.no_rm },
        // { label: "Umur", value: this.ralan.pasien.formatted_umur },
        {
          label: "Diagnosa",
          value: `${
            this.ralan.rln_periksa_dok
              ? `Dx Utama: ${this.ralan.rln_periksa_dok.dx_utama}`
              : `__________________________________________________`
          }
        ${
          this.ralan.rln_periksa_dok
            ? `Dx Sekunder: ${this.ralan.rln_periksa_dok.dx_sekunder}`
            : `__________________________________________________`
        }
        ${
          this.ralan.rln_periksa_dok
            ? "Klasifikasi Medis: " +
              this.ralan.rln_periksa_dok.rln_periksa_dok_penyakit
                .map((item) => {
                  return (
                    item.penyakit.tipe +
                    ` ` +
                    item.penyakit.kode +
                    ` - ` +
                    item.penyakit.desc_short
                  );
                })
                .join(",")
            : `__________________________________________________`
        }`,
        },
        {
          label: "Terapi",
          value: "__________________________________________________",
        },
      ],
      p2: "Tindak lanjut yang dianjurkan ",
      arr2: [
        {
          label: "[ _ ] Pengobatan dengan obat-obatan",
          value: `__________________________________________________`,
        },
        {
          label: "[ _ ] Kontrol kembali ke RS tanggal",
          value: `__________________________________________________`,
        },
        {
          label: "[ _ ] Perlu rawat inap",
          value: `__________________________________________________`,
        },
        {
          label: "[ _ ] Konsultasi",
          value: `__________________________________________________`,
        },
        {
          label: "[ _ ] Lain-lain",
          value: `__________________________________________________
        `,
        },
      ],
    };
    var sign = `Pekanbaru, ________________________

      Dokter RS




      ( ${this.ralan.dokter.nama} )`;
    let arr1 = labelValueFormatter(draft.arr1, 200);
    let arr2 = labelValueFormatter(draft.arr2, 200);
    this.content = [
      {
        image: headerImage,
        width: 529,
      },
      {
        text: draft.title,
        style: "title",
      },
      {
        text: draft.subtitle,
        style: "subtitle",
      },
      {
        style: "paragraph",
        text: draft.intro,
      },
      {
        style: "paragraph",
        text: draft.p1,
      },
      ...arr1,
      {
        style: "paragraph",
        text: draft.p2,
      },
      ...arr2,
      {
        columns: [
          { text: "" },
          {
            style: "sign",
            text: sign,
          },
        ],
      },
    ];
  },
};
</script>
